import * as WorkListsDAO from "@/dao/worklists-dao";

export default {
  async getMyWorkLists({ commit }, { location, medKeyType }) {
    const workLists = await WorkListsDAO.getMyWorkLists(location, medKeyType);
    commit("setWorkListsIds", workLists.data);
  },
  async getMyWorkListsById({ state, commit }) {
    const workList = await WorkListsDAO.getMyWorkListsById(state.workListsIds[0].id);
    commit("setCurrentWorkList", workList);
  },
  async increase({ commit, getters }, { listId, pillId }) {
    const pill = getters.currentWorkList.find((o) => o.id === pillId);
    const pillData = { ...pill, amountOfCanisters: (isNaN(pill.amountOfCanisters) ? 0 : pill.amountOfCanisters) + 1 };

    const data = await WorkListsDAO.updatePillsOnWorkList(listId, [pillData]);
    commit("setCanisterAmountForOrder", data.canisterAmountForOrder);
    commit("setPillAmountForCheckData", data.pillAmountForCheckData);
    commit("increaseAmountOfCanistersByPillId", pillId);
  },
  async decrease({ commit, getters, dispatch }, { listId, pillId }) {
    const pill = getters.currentWorkList.find((o) => o.id === pillId);
    const pillData = { ...pill, amountOfCanisters: (isNaN(pill.amountOfCanisters) ? 0 : pill.amountOfCanisters) - 1 };
    const data = await WorkListsDAO.updatePillsOnWorkList(listId, [pillData]);
    commit("setCanisterAmountForOrder", data.canisterAmountForOrder);
    commit("setPillAmountForCheckData", data.pillAmountForCheckData);

    await commit("decreaseAmountOfCanistersByPillId", pillId);
    if (pillData.amountOfCanisters === 0) {
      await dispatch("getMyWorkListsById");
    }
  },
  setAmount({ commit }, { listId, pill, value }) {
    commit("setAmountOfCanistersByPillId", { pillId: pill.id, value });
    return WorkListsDAO.updatePillsOnWorkList(listId, [pill]);
  },
  async increaseByIdsList({ commit, dispatch }, { listId, idsList, value, query }) {
    idsList.forEach((o) => commit("setAmountOfCanistersByPillId", { pillId: o.id, value }));
    if (value === 0) {
      const data = await WorkListsDAO.updatePillsOnWorkList(listId, idsList, query);
      commit("setCanisterAmountForOrder", data.canisterAmountForOrder);
      commit("setPillAmountForCheckData", data.pillAmountForCheckData);
      dispatch("getMyWorkListsById");
    } else {
      const data = await WorkListsDAO.updatePillsOnWorkList(listId, idsList, query);
      commit("setCanisterAmountForOrder", data.canisterAmountForOrder);
      commit("setPillAmountForCheckData", data.pillAmountForCheckData);
    }
  },
};
